<template>
  <!--分类模板-->
  <div class="template home-border">
    <div v-for="item in templateList" :key="item.id">
      <!--标题-->
      <div class="temp-title">
        <h2>{{ item.name }}</h2>
        <router-link
          :to="`/template_list?id=${item.id}&name=${item.name}&type=template`"
          >更多</router-link
        >
      </div>
      <!--模板-->
      <div class="temp-list">
        <ul>
          <template v-for="(child, index) in item.template_info">
            <li :key="child.id" v-if="index < 6" @click="gotoTemp(child)">
              <div class="temp-img">
                <el-image :src="child.url" />
              </div>
              <p class="text-hidden">{{ child.name }}</p>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Home } from "@/config/axios/new_api";

export default {
  data() {
    return {
      templateList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
        let res = await Home.getData({ type: 4 })
        if (Array.isArray(res.data)) {
          this.templateList = res.data.map((item) => {
            item.name_edit_status = false;
            var issafariBrowser =
              /Safari/.test(navigator.userAgent) &&
              !/Chrome/.test(navigator.userAgent);
            item.template_info = item.template_info.map((child) => {
              child.url = issafariBrowser
                ? child.cover_url
                : child.thumbnail_url;
              return child;
            });
            return item;
          });
        }
    },
    gotoTemp(item) {
      if (item.path_type === 1) {
        this.$router.push({
          name: "TemplateList",
          query: {
            id: item.directories_id,
            name: item.name,
            type: "icon",
          },
        });
      } else {
        this.goDesignworkbench(item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.template {
  margin-top: 18px;
  padding: 10px;
  .temp-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include wh(100%, 40px);
    margin-bottom: 30px;
    line-height: 40px;
    h2 {
      font-size: 22px;
    }
    a {
      display: block;
      @include wh(100px, 40px);
      background: #f3f3f3;
      border-radius: 4px;
      text-align: center;
      color: #3b3946;
    }
  }
  .temp-list {
    @include wh(100%, 200px);
    li {
      width: 150px;
      margin-right: 60px;
      float: left;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      .temp-img {
        @include wh(150px, 150px);
        // background: #3b3946;
        border-radius: 8px;
        &:hover {
          background: $hoverColor;
        }
        ::v-deep( .el-image) {
          @include wh(100%, 150px);
        }
        ::v-deep( .el-image__inner) {
          @include wh(100%, 150px);
          object-fit: contain;
        }
      }
      p {
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        width: 100%;
        padding: 0 10px;
        margin-top: 8px;
      }
    }
  }
}
</style>
